module.exports = __webpack_public_path__ + "static/media/coffeeCup.198be5fa.jpg";